import { Purchases, LOG_LEVEL } from '@revenuecat/purchases-capacitor';
import { isNative } from '../config/apiConfig';

// ─── Config ───────────────────────────────────────────────────────────────────
// RevenueCat Dashboard → Apps → iOS → API Key
const RC_API_KEY_IOS = process.env.REACT_APP_RC_API_KEY_IOS || 'appl_DEIN_REVENUECAT_KEY';

// Entitlement & Product IDs (müssen mit RevenueCat Dashboard übereinstimmen)
export const ENTITLEMENT_PRO   = 'pro';
export const PRODUCT_MONTHLY   = 'bullivo_pro_monthly';
export const PRODUCT_YEARLY    = 'bullivo_pro_annual';

let initialized = false;
let _initPromise = null;

// ─── Init ─────────────────────────────────────────────────────────────────────
export function initRevenueCat(userId = null) {
  if (!isNative()) return Promise.resolve();
  if (initialized) return Promise.resolve();
  if (_initPromise) return _initPromise;
  if (RC_API_KEY_IOS.startsWith('test_') || RC_API_KEY_IOS.startsWith('appl_DEIN')) return Promise.resolve();

  _initPromise = (async () => {
    try {
      await Purchases.setLogLevel({ level: LOG_LEVEL.ERROR });
      await Purchases.configure({ apiKey: RC_API_KEY_IOS });
      if (userId) await Purchases.logIn({ appUserID: userId });
      initialized = true;
    } catch (err) {
      console.error('[RC] init error:', err);
    }
  })();
  return _initPromise;
}

// ─── Check Premium Status ──────────────────────────────────────────────────────
export async function checkPremiumStatus() {
  if (!isNative()) return false;
  try {
    await initRevenueCat(null);
    const { customerInfo } = await Purchases.getCustomerInfo();
    return customerInfo.entitlements.active[ENTITLEMENT_PRO] !== undefined;
  } catch { return false; }
}

// ─── Fetch Offerings ──────────────────────────────────────────────────────────
export async function getOfferings() {
  if (!isNative()) return null;
  try {
    await initRevenueCat(null); // sicherstellen dass RC initialisiert ist
    const { current } = await Purchases.getOfferings();
    return current;
  } catch (err) {
    console.error('[RC] getOfferings:', err);
    return null;
  }
}

// ─── Purchase ─────────────────────────────────────────────────────────────────
export async function purchasePackage(pkg) {
  const { customerInfo } = await Purchases.purchasePackage({ aPackage: pkg });
  const isPremium = customerInfo.entitlements.active[ENTITLEMENT_PRO] !== undefined;
  return isPremium;
}

// ─── Restore ──────────────────────────────────────────────────────────────────
export async function restorePurchases() {
  const { customerInfo } = await Purchases.restorePurchases();
  return customerInfo.entitlements.active[ENTITLEMENT_PRO] !== undefined;
}
